var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-5"},[(_vm.isItAdmin)?_c('div',_vm._l((_vm.cities),function(c){return _c('city',{key:c.color,attrs:{"item":c}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }